import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import classNames from 'classnames';
import React, { Component, createRef } from 'react';
import { CLS_PREFIX } from '../../constants';
import calculateNodeHeight from './calculateNodeHeight';

var getMinMax = function getMinMax(rows) {
  if (typeof rows === 'number') {
    return {
      minRows: rows
    };
  } else if (_typeof(rows) === 'object' && typeof rows.min === 'number' && typeof rows.max === 'number') {
    return {
      minRows: rows.min,
      maxRows: rows.max
    };
  }

  return null;
};

var AVAILABLE_SIZES = ['sm', 'md', 'lg', 'xl', 'fill'];
/**
 * `TextArea` is used for entering long text (like email body, descriptions, comments).
 * @since 1.9.0
 */

var TextArea =
/*#__PURE__*/
function (_Component) {
  _inherits(TextArea, _Component);

  function TextArea() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextArea)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      textareaStyles: null
    });

    _defineProperty(_assertThisInitialized(_this), "rootRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var _this$props = _this.props,
          autoheight = _this$props.autoheight,
          onChange = _this$props.onChange;

      if (autoheight) {
        _this.adjustHeight();
      }

      if (typeof onChange === 'function') {
        onChange(e);
      }
    });

    return _this;
  }

  _createClass(TextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.adjustHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var autoheight = this.props.autoheight;

      if (autoheight !== prevProps.autoheight) {
        this.adjustHeight();
      }
    }
  }, {
    key: "adjustHeight",
    value: function adjustHeight() {
      var autoheight = this.props.autoheight;

      if (!autoheight) {
        this.setState({
          textareaStyles: null
        });
        return;
      }

      var _this$state = this.state,
          minRows = _this$state.minRows,
          maxRows = _this$state.maxRows;

      if (this.rootRef.current) {
        var textareaStyles = calculateNodeHeight(this.rootRef.current, false, minRows, maxRows);
        this.setState({
          textareaStyles: textareaStyles
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          baseClassName = _this$props2.baseClassName,
          className = _this$props2.className,
          rows = _this$props2.rows,
          size = _this$props2.size,
          autoheight = _this$props2.autoheight,
          onChange = _this$props2.onChange,
          other = _objectWithoutProperties(_this$props2, ["baseClassName", "className", "rows", "size", "autoheight", "onChange"]);

      var _this$state2 = this.state,
          textareaStyles = _this$state2.textareaStyles,
          minRows = _this$state2.minRows;
      var useSizeModifier = AVAILABLE_SIZES.indexOf(size) !== -1;
      return React.createElement("textarea", _extends({
        className: classNames(baseClassName, _defineProperty({}, "".concat(baseClassName, "--size-").concat(size), useSizeModifier), className),
        ref: this.rootRef,
        style: textareaStyles,
        onChange: this.handleChange,
        rows: minRows
      }, other));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref) {
      var rows = _ref.rows;

      if (rows) {
        return getMinMax(rows);
      }

      return null;
    }
  }]);

  return TextArea;
}(Component);

_defineProperty(TextArea, "defaultProps", {
  baseClassName: "".concat(CLS_PREFIX, "textarea"),
  className: null,
  rows: 4,
  size: 'md',
  autoheight: false,
  onChange: null
});

export default TextArea;